import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0002 4.59999C7.91333 4.59999 4.60039 7.91293 4.60039 11.9998C4.60039 16.0866 7.91333 19.3995 12.0002 19.3995C16.087 19.3995 19.3999 16.0866 19.3999 11.9998C19.3999 7.91293 16.087 4.59999 12.0002 4.59999ZM3.40039 11.9998C3.40039 7.25019 7.25058 3.39999 12.0002 3.39999C16.7497 3.39999 20.5999 7.25019 20.5999 11.9998C20.5999 16.7493 16.7497 20.5995 12.0002 20.5995C7.25058 20.5995 3.40039 16.7493 3.40039 11.9998Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0083 6.58876C9.40052 7.94269 9.00914 9.85523 9.00914 11.9998C9.00914 14.1443 9.40054 16.0568 10.0083 17.4108C10.6416 18.8216 11.3924 19.3995 12 19.3995C12.6075 19.3995 13.3583 18.8216 13.9915 17.4108C14.5992 16.0568 14.9906 14.1443 14.9906 11.9998C14.9906 9.85522 14.5993 7.94267 13.9916 6.58874C13.3584 5.17793 12.6076 4.59999 12 4.59999C11.3924 4.59999 10.6415 5.17797 10.0083 6.58876ZM8.9135 6.09734C9.57988 4.6128 10.6245 3.39999 12 3.39999C13.3756 3.39999 14.4201 4.61284 15.0864 6.09736C15.7782 7.63876 16.1906 9.7261 16.1906 11.9998C16.1906 14.2734 15.7781 16.3608 15.0863 17.9022C14.42 19.3867 13.3755 20.5995 12 20.5995C10.6245 20.5995 9.57991 19.3867 8.91353 17.9022C8.22162 16.3608 7.80914 14.2734 7.80914 11.9998C7.80914 9.72609 8.22161 7.63875 8.9135 6.09734Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.54291 7.87792C4.54291 7.54655 4.81154 7.27792 5.14291 7.27792H18.8558C19.1872 7.27792 19.4558 7.54655 19.4558 7.87792C19.4558 8.20929 19.1872 8.47792 18.8558 8.47792H5.14291C4.81154 8.47792 4.54291 8.20929 4.54291 7.87792Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.39996 12.0011C3.39996 11.6697 3.66859 11.4011 3.99996 11.4011H19.9995C20.3309 11.4011 20.5995 11.6697 20.5995 12.0011C20.5995 12.3325 20.3309 12.6011 19.9995 12.6011H3.99996C3.66859 12.6011 3.39996 12.3325 3.39996 12.0011Z"
      fill={props.color || 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.54291 16.121C4.54291 15.7896 4.81154 15.521 5.14291 15.521H18.8558C19.1872 15.521 19.4558 15.7896 19.4558 16.121C19.4558 16.4524 19.1872 16.721 18.8558 16.721H5.14291C4.81154 16.721 4.54291 16.4524 4.54291 16.121Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgGlobal = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgGlobal;
